module.exports = __webpack_public_path__ + "fc86453ddd9520386714a2ec63d8115a.pdf";